export const LOGOUT = 'LOGOUT';

export const SET_IS_CONNECTED = 'SET_IS_CONNECTED';
export const SET_WEBSOCKET_DATA = 'SET_WEBSOCKET_DATA';

export const SET_TIMEOUT_ID = 'SET_TIMEOUT_ID';
